import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Input,
  Label,
  FormGroup
} from 'reactstrap';
import * as commonActions from '@common/common.action';
import * as actions from '../../solicitacao.action';
import SelectComponent from '@componentes/select/select.component';
import SolicitacaoApi from '../../solicitacao.api';
import {
  tiposSolicitacoesEnumList,
  tiposSolicitacoesEnum
} from '../../solicitacao.utils';
import WebapiCommon from '@common/util/webapi.common';
import IntlMessage from '../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

function ModalCriarSolicitacao({ showModal, onModal, laudoSelecionado }) {

  const intl = useIntl();

	function translate(key) {
	  return intl.formatMessage({ id: key });
	}
  
  const dispatch = useDispatch();

  const totalSolicitado = useSelector(
    state => state.solicitacao.totalSolicitado
  );

  const [modalAberto, setModalAberto] = useState(false);
  const [solicitacao, setSolicitacao] = useState({});
  const [frascos, setFrascos] = useState([]);
  const [blocos, setBlocos] = useState([]);
  const [coloracoes, setColoracoes] = useState([]);

  useEffect(() => {
    setModalAberto(showModal);
    dispatch(commonActions.showModal(showModal));
    const { laudo, nrExame } = laudoSelecionado;
    laudo && loadItens(laudo);
    setSolicitacao({ laudo, nrExame });
  }, [showModal, laudoSelecionado]);

  useEffect(() => {
    if (solicitacao.tipo === tiposSolicitacoesEnum.NOVO_CORTE) {
      setSolicitacao({ ...solicitacao, bloco: null, coloracoes: [] });
    }
    if (solicitacao.tipo === tiposSolicitacoesEnum.APROFUNDAMENTO) {
      setSolicitacao({ ...solicitacao, frasco: null });
    }
  }, [solicitacao.tipo]);

   function loadItens(laudo) {
      dispatch(commonActions.showFadeCarregando(true));
       Promise.all([
        SolicitacaoApi.getFrascos(laudo),
        SolicitacaoApi.getBlocos(laudo),
        WebapiCommon.getColoracoes(laudo)
      ]).then((response)=>{
        let respFrascos = response[0];
        let respBlocos = response[1];
        let respColoracao = response[2];

        const frascosFormatted = respFrascos.map(x => ({
          value: x.frascoId,
          label: `${translate("general.requestsPanel.bottle")} ${x.dsFrasco} ${x.topografia}`
        }));
        setFrascos(frascosFormatted);
  
        const blocosFormatted = respBlocos.map(x => ({
          value: x.id,
          label: x.numeroBloco
        }));
        setBlocos(blocosFormatted);
        setColoracoes(respColoracao);
        dispatch(commonActions.showFadeCarregando(false));
      }).catch ((error) => {
      const mensagem = translate("general.requestsPanel.errorListingItems");
      dispatch(commonActions.showAlerta(translate("general.requestsPanel.error"), mensagem, 3000));
      dispatch(commonActions.showFadeCarregando(false));
    });
  };

  const onChangeColoracoes = value => {
    let selecionadas = [];
    value.forEach(color => {
      selecionadas = color.coloracoes
        ? [...selecionadas, ...color.coloracoes]
        : [...selecionadas, color];
    });
    selecionadas = Array.from(new Set(selecionadas.map(JSON.stringify))).map(
      JSON.parse
    );
    setSolicitacao({ ...solicitacao, coloracoes: selecionadas });
  };

  const toggle = () => {
    setModalAberto(!modalAberto);
    dispatch(commonActions.showModal(!modalAberto));
    onModal(!modalAberto);
  };

  const salvar = () => {
    if (
      solicitacao.tipo !== tiposSolicitacoesEnum.NOVO_CORTE &&
      solicitacao.tipo !== tiposSolicitacoesEnum.APROFUNDAMENTO
    ) {
      const mensagem = `${translate("general.requestsPanel.necessaryInformType")}`;
      return dispatch(commonActions.showAlerta(`${translate("general.requestsPanel.error")}`, mensagem, 3000));
    }

    if (
      solicitacao.tipo === tiposSolicitacoesEnum.NOVO_CORTE &&
      !solicitacao.frasco
    ) {
      const mensagem = `${translate("general.requestsPanel.necessaryInformBottle")}`;
      return dispatch(commonActions.showAlerta(`${translate("general.requestsPanel.error")}`, mensagem, 3000));
    }

    if (
      solicitacao.tipo === tiposSolicitacoesEnum.APROFUNDAMENTO &&
      !solicitacao.bloco
    ) {
      const mensagem = `${translate("general.requestsPanel.necessaryInformBlock")}`;
      return dispatch(commonActions.showAlerta(`${translate("general.requestsPanel.error")}`, mensagem, 3000));
    }

    const coloracoes =
      solicitacao.coloracoes && !!solicitacao.coloracoes.length
        ? solicitacao.coloracoes.map(c => c.id)
        : [];
    const body = { ...solicitacao, coloracoes };

    dispatch(commonActions.showFadeCarregando(true));
    SolicitacaoApi.post(body).then(() => {
      dispatch(commonActions.showFadeCarregando(false));
      toggle();
      const mensagem = `${translate("general.requestsPanel.requestCreatedSuccessfully")}`;
      dispatch(commonActions.showAlerta(`${translate("general.requestsPanel.success")}`, mensagem, 3000));
      dispatch(actions.setTotalSolicitado(totalSolicitado + 1));
    });
  };

  return (
    <React.Fragment>
      <div>
        <Modal
          className='modal-lg'
          centered
          backdrop={false}
          keyboard={true}
          isOpen={modalAberto}
          toggle={toggle}
        >
          <ModalHeader toggle={toggle}><IntlMessage id="general.requestsPanel.registrationOfRequests" /></ModalHeader>

          <ModalBody>
            <Row>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id="general.requestsPanel.exam" />:</Label>
                  <Input value={solicitacao.nrExame} readOnly={true} />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id="general.requestsPanel.type" />:</Label>
                  <SelectComponent
                    options={tiposSolicitacoesEnumList}
                    onChange={e =>
                      setSolicitacao({ ...solicitacao, tipo: e.value })
                    }
                    placeholder='Selecione o tipo'
                    styles={{ borderColor: 'transparent' }}
                  />
                </FormGroup>
              </Col>
            </Row>
            {solicitacao.tipo === tiposSolicitacoesEnum.NOVO_CORTE && (
              <Row>
                <Col>
                  <FormGroup>
                    <Label><IntlMessage id="general.requestsPanel.type" />:</Label>
                    <SelectComponent
                      options={frascos}
                      onChange={e =>
                        setSolicitacao({ ...solicitacao, frasco: e.value })
                      }
                      placeholder={translate("general.requestsPanel.selectType")}
                      styles={{ borderColor: 'transparent' }}
                    />
                  </FormGroup>
                </Col>
              </Row>
            )}
            {solicitacao.tipo === tiposSolicitacoesEnum.APROFUNDAMENTO && (
              <Row>
                <Col>
                  <FormGroup>
                    <Label><IntlMessage id="general.requestsPanel.block" />:</Label>
                    <SelectComponent
                      options={blocos}
                      onChange={e =>
                        setSolicitacao({ ...solicitacao, bloco: e.value })
                      }
                      placeholder={translate("general.requestsPanel.selectBlock")}
                      styles={{ borderColor: 'transparent' }}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label><IntlMessage id="general.requestsPanel.colorations" />:</Label>
                    <SelectComponent
                      isMulti
                      options={coloracoes}
                      value={solicitacao.coloracoes}
                      onChange={e => onChangeColoracoes(e)}
                      placeholder={translate("general.requestsPanel.selectColors")}
                      styles={{ borderColor: 'transparent' }}
                    />
                  </FormGroup>
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id="general.requestsPanel.comment" />:</Label>
                  <Input
                    type='textarea'
                    rows={3}
                    value={solicitacao.comentario}
                    onChange={e =>
                      setSolicitacao({
                        ...solicitacao,
                        comentario: e.target.value
                      })
                    }
                  />
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>

          <ModalFooter>
            <Button
              onClick={toggle}
              className={`button-cancel`}
              color='secondary'
            >
              <IntlMessage id="general.requestsPanel.close" />
            </Button>
            <Button color='primary' onClick={salvar}>
              <IntlMessage id="general.requestsPanel.save" />
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
}

export default ModalCriarSolicitacao;



// WEBPACK FOOTER //
// ./src/pages/solicitacao/Laudos/CriarSolicitacao/index.js